<template>
<div class="alls-item">
    <a :href="info.id|idHostBuild(app,topic.englishName)">
    <div class="top-wrap">
        <span class="system">[{{app|appName}}]</span>
        <span class="title" v-html="title"></span>
        <span class="view" v-if="view > 50"><i class="yk-home_view"></i>  {{view|numberFormat}}</span>
        <span class="time"><i class="yk-watch"></i> {{createdAt|timeFormat('y-m-d')}}</span>
    </div>
    <div class="bottom-cont" v-html="content"></div>
    </a>
</div>
</template>
<script>
export default {
    name:'ItemAll',
    props:['info','keyword'],
    computed:{
        app(){
            return this.info.app;
        },
        title(){
            if( this.keyword.length == 0 ) return this.title;
            var title = this.info.title;
            var reg = new RegExp(this.keyword,'g');
            var result = title.replace(reg,function($1){
                return '<span class="keyword-required">'+ $1+ '</span>'
            })
            return result;
        },
        content(){
            var content = this.info.content;
            let fragment = document.createDocumentFragment();
            let tmp = fragment.appendChild(document.createElement('div'));
            
            tmp.innerHTML = content;
            var contStr = tmp.innerText;
            if( this.keyword.length == 0 ) return  contStr;
            var reg = new RegExp(this.keyword,'g');
            return contStr.replace(reg,function($1){
                return '<span class="keyword-required">'+ $1+ '</span>'
            })
        },
        view(){
            return this.info.property.view||0
        },
        createdAt(){
            return this.info.createdAt;
        },
        topic(){
            return this.info.property.topic[0]||{}
        }
    },
    created(){

    }
  
}
</script>
<style lang="scss" scoped>
.alls-item{
    padding: 15px 0;
    .top-wrap{
        line-height: 24px;
        .system,.title{font-size: 18px;}
        .title{margin: 0 10px 0 5px; font-size: 18px;}
        .view,.time{font-size: 16px;  color: #999;margin-right: 10px;}
    }
    
    .bottom-cont{
        white-space: nowrap; font-size: 14px; line-height: 20px; color: #999; overflow: hidden; text-overflow:ellipsis;  
        margin-top: 10px;
    }
    ::v-deep{
        .keyword-required{color: #e43a3a; }
    }
    a:hover{
        .title{text-decoration: underline;}
    }
}
</style>